/*
 * Copyright (c) 2018 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained here in is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */
import { createStyles, Theme } from "@material-ui/core";
import { theme } from "../../theme/theme";

export const styles = ({spacing}: Theme) => createStyles({
    container: {
        maxWidth: 1024,
        marginLeft: "auto",
        marginRight: "auto",
        padding: `${spacing.unit * 5}px 0`,
        justifyContent: "space-between",
        [theme.breakpoints.down(1100)]: {
            marginLeft: `${spacing.unit * 5}px`,
            marginRight: `${spacing.unit * 5}px`,
            width: "calc(100% - 80px)",
        }
    },
    left: {
        paddingRight: spacing.unit * 4,
    }
});


// WEBPACK FOOTER //
// ./src/pages/PageProduct/PageProduct.style.tsx